import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ButtonLine } from "../fluent/hoc/buttonLine";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
export class ButtonLineComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    renderFluent() {
        // NOTE when callsit replaces usage of this with the ButtonLine, can pass in a true fluent icon
        const fluentIcon = this.props.icon ? () => _jsx("img", { src: this.props.icon, title: this.props.iconLabel, alt: this.props.iconLabel, className: "icon" }) : undefined;
        return _jsx(ButtonLine, { label: this.props.label, icon: fluentIcon, onClick: this.props.onClick, disabled: this.props.isDisabled });
    }
    renderOriginal() {
        return (_jsxs("div", { className: "buttonLine" + (this.props.isDisabled ? " disabled" : ""), children: [this.props.icon && _jsx("img", { src: this.props.icon, title: this.props.iconLabel, alt: this.props.iconLabel, className: "icon" }), _jsx("button", { disabled: this.props.isDisabled, onClick: () => this.props.onClick(), children: this.props.label })] }));
    }
    render() {
        return _jsx(ToolContext.Consumer, { children: ({ useFluent }) => (useFluent ? this.renderFluent() : this.renderOriginal()) });
    }
}
//# sourceMappingURL=buttonLineComponent.js.map